import { createSlice } from '@reduxjs/toolkit';

const dropdownSlice = createSlice({
  name: 'dropdown',
  initialState: { id: null, task: '', history_id: null },
  reducers: {
    setDropdownValue: (state, action) => {
      return {
        id: action.payload.id,
        task: action.payload.task,
        history_id: state.history_id
      };
    },
    setHistoryId: (state, action) => {
      state.history_id = action.payload;
    },
    resetDropdownValue: (state) => {
      return {
        id: null,
        task: '',
        history_id: state.history_id
      };
    },
  },
});

const fileSlice = createSlice({
  name: 'file',
  initialState: null,
  reducers: {
    setFileValue: (state, action) => action.payload,
  },
});

export const { setDropdownValue, setHistoryId, resetDropdownValue } = dropdownSlice.actions;
export const { setFileValue } = fileSlice.actions;

export const dropdownReducer = dropdownSlice.reducer;
export const fileReducer = fileSlice.reducer;